/**
 * @generated SignedSource<<c16c75edddf6e88349d6d9573b358aaf>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ConfigureRoundGolfPlayerRateControl_Booking$data = {
  readonly " $fragmentSpreads": FragmentRefs<"useGetGolfPlayerRateOptions_Booking">;
  readonly " $fragmentType": "ConfigureRoundGolfPlayerRateControl_Booking";
};
export type ConfigureRoundGolfPlayerRateControl_Booking$key = {
  readonly " $data"?: ConfigureRoundGolfPlayerRateControl_Booking$data;
  readonly " $fragmentSpreads": FragmentRefs<"ConfigureRoundGolfPlayerRateControl_Booking">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ConfigureRoundGolfPlayerRateControl_Booking",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useGetGolfPlayerRateOptions_Booking"
    }
  ],
  "type": "Booking",
  "abstractKey": "__isBooking"
};

(node as any).hash = "fb73ba2d6d6cc5765d0d87a28aff4ba6";

export default node;
